// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import DismissContainer from './DismissContainer';

import '../styles/actionMenu.css';

export default class ActionMenu extends React.Component {
    state={
        open: false, 
    }

    render = () => {        
        return (
            <div
                className='action-menu'
            >
                <div
                    onClick={() => this.setState({open: !this.state.open})}
                >
                    {this.props.label}
                </div>
                {
                    this.state.open?
                    <DismissContainer
                        onClose={() => this.setState({open: false})}
                    >
                        <div
                            className='action-menu-dropdown'
                            style={{
                                overflow: 'hidden',
                                zIndex: 1000,
                            }}
                        >
                            {
                            this.props.actions.map((action) => {
                                return (
                                    <div className='action-menu-option' onClick={action.action}>{action.label}</div>
                                )
                            })
                            }
                        </div>
                    </DismissContainer>:''
                }
            </div>
        );
    }

};